import { css } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';

export const incidentDialogClassName = css`
  background: transparent;
  justify-content: center;
  align-items: flex-end;

  [data-name="dialog-wrapper"] {
    width: 100% !important;
    max-width: 100% !important;
    border: 1px solid ${getThemeColor('accent')};
    border-radius: 15px 15px 0 0;
    opacity: 0.9;
  }
`;

export const incidentDialogDesktopClassName = css`
  background: transparent;
  justify-content: flex-end;
  align-items: flex-start;
  margin: 45px 10px 10px 10px;
  width: auto;
  height: auto;

  [data-name="dialog-wrapper"] {
    border: 1px solid ${getThemeColor('accent')};
    opacity: 0.9;
  }
`;

export const incidentDialogRetailTVClassName = css`
  background: transparent;
  justify-content: flex-end;
  align-items: flex-start;
  margin: 45px 10px 10px 10px;
  width: auto;
  height: auto;

  [data-name="dialog-wrapper"] {
    padding-top: 20px;
    border: 1px solid ${getThemeColor('accent')};
    opacity: 0.9;
    width: 450px;
    height: 250px;
    font-size: 1.2rem;

    [data-e2e="dialog-title"] {
      font-size: 1.5rem;
      margin-bottom: 30px;
      margin-top: 10px;
    }

    [data-e2e="dialog-buttons"] {
      margin-top: 34px;
    }
  }
`;
